import React from "react"
import { Dropdown } from "semantic-ui-react"

const FilterSortBy = ( { sort, onChange } ) => (
    <Dropdown
      trigger={<span><span className="dn dib-ns">{translate( "Sortieren nach" )}:</span> <span className="b">{translate( sort )}</span></span>}>
      <Dropdown.Menu>
        <Dropdown.Item onClick={() => {
          onChange( "price" )
        }} text="Preis"/>
        <Dropdown.Item onClick={() => {
          onChange( "sort" )
        }} text="Standard"/>
        <Dropdown.Item onClick={() => {
          onChange( "des" )
        }} text="Alphabetisch"/>
        <Dropdown.Item onClick={() => {
          onChange( "creationdate" )
        }} text="Neuheit"/>
        <Dropdown.Item onClick={() => {
          onChange( "article_nr" )
        }} text="Art-Nr."/>
      </Dropdown.Menu>
    </Dropdown>
)
export default FilterSortBy



// WEBPACK FOOTER //
// ./src/components/Filter/FilterSortBy.js